class VatRateOverrideGroupController extends AbstractEntityEditController
	@register()
	@inject 'translate',
		'vatRates'
		'vatRateOverrideGroup'
		'VatRateOverrideGroupRepository'

	initialize: ->
		@mainCrud.entityType = 'general.vat_rate_override_group'
		@mainCrud.isNewEntity = !@vatRateOverrideGroup.id?

		if !@mainCrud.isNewEntity
			@mainCrud.entityTitle = @vatRateOverrideGroup.name
		else
			@mainCrud.entityTitle = 'general.vat_rate_override_group.new'
			@vatRateOverrideGroup.vat_rate_overrides = []

	save: ->
		@mainCrud.saving = true

		@VatRateOverrideGroupRepository
			.save @vatRateOverrideGroup, @mainCrud.isNewEntity
			.then (response) =>
				@vatRateOverrideGroup = response.data
				@afterSave response
			.catch (result) =>
				@handleErrors result 'general.vat_rate_override_group'

	delete: ->
		@deleteEntity @VatRateOverrideGroupRepository, @vatRateOverrideGroup

	addVatRateOverride: ->
		@vatRateOverrideGroup.vat_rate_overrides.push
			vat_rate_id: null,
			override_vat_rate_id: null

		@mainCrud.parent_form.$setDirty()

	removeVatRateOverride: (index) ->
		@vatRateOverrideGroup.vat_rate_overrides.splice index, 1

		@mainCrud.parent_form.$setDirty()

		@onVatRateSelectChange()

	onVatRateSelectChange: ->
		@resetErrors()

		usageCount = @countVatRateUsage(@vatRates, @vatRateOverrideGroup.vat_rate_overrides)

		for vatRate in @vatRates
			if usageCount[vatRate.id] > 1
				@addErrorMessage(
					@translate('general.vat_rate'),
					'general.vat_rate_override_group.vat_rate.used'
				)

		@mainCrud.parent_form.$setValidity 'vat_rate', !@hasErrorMessages()

	countVatRateUsage: (vatRates, vatRateOverrides) ->
		usageCount = _.chain(vatRates)
			.map((vatRate) => [vatRate.id, 0])
			.object()
			.value()

		for override in vatRateOverrides
			if override.vat_rate_id of usageCount
				usageCount[override.vat_rate_id]++
			if override.override_vat_rate_id of usageCount
				usageCount[override.override_vat_rate_id]++

		return usageCount

	# This check is needed because a VAT rate can be used only once, no matter if it is overridden or being an override
	canAddNewVatRateOverride: ->
		return @vatRateOverrideGroup.vat_rate_overrides.length < Math.floor(@vatRates.length / 2)
